import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSearchSuggestions, clearSearch } from "../../../slices/search";
import { BiSearch } from "react-icons/bi";
import useDeviceType from "../../helpers/GetDevice";
export default function SearchDropdown() {
  const dispatch = useDispatch();
  const { suggestions, loading } = useSelector((state) => state.search);
  const [query, setQuery] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (query.trim()) {
      dispatch(fetchSearchSuggestions(query));
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
      dispatch(clearSearch());
    }
  }, [query, dispatch]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
        setShowInput(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  const deviceType = useDeviceType();
return (
  <div
    className="position-relative"
    ref={dropdownRef}
    style={{
      minWidth: deviceType === "desktop" ? 200 : "200px",
      display: "flex",
      justifyContent: deviceType === "desktop" ? "flex-start" : "center",
    }}
  >
    <div style={{ width: deviceType === "desktop" ? 200 : "90%" }}>
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search products..."
        autoFocus
        className="form-control"
        style={{
          borderRadius: 50,
          padding: "8px 16px",
          border: "1px solid #ccc",
          width: "100%",
          transition: "width 0.3s ease",
        }}
      />

      {showDropdown && suggestions.length > 0 && (
        <ul
          className="dropdown-menu show"
 style={{
    position: "absolute",
    left: "20%",
    transform: "translateX(-50%)",   // center align
    width: deviceType === "desktop" ? "550px" : "350px",
    maxHeight: 300,
    overflowY: "auto",
    borderRadius: 8,
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    marginTop: 10,
    display: "block",
    padding: 0,
  }}
        >
          {loading ? (
            <li className="dropdown-item">Loading...</li>
          ) : (
            suggestions.map((sug) => (
              <li
                key={sug.id}
                className="dropdown-item d-flex align-items-center"
                style={{ cursor: "pointer", padding: "8px 12px" ,overflowX:"hidden"}}
                onClick={() =>
                  (window.location.href = `/product/${sug.slug}`)
                }
              >
                {sug.primary_image && (
                  <img
                    src={sug.primary_image}
                    alt={sug.name}
                    style={{
                      width: 40,
                      height: 40,
                      objectFit: "cover",
                      marginRight: 10,
                      borderRadius: 4,
                    }}
                  />
                )}
                <div>
                  <div
                    style={{
                      fontWeight: 500,
                      fontSize: 12,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {sug.name}
                  </div>
                </div>
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  </div>
);

}
